import TableContainer from 'components/TableContainer'
import React, { useCallback } from 'react'
import ImpervaAPI from 'restAPI/ImpervaAPI'
import { CellRenderers, Sorters } from 'utils/tableUtils'
import { ToggleButton } from '../IntegrationsTable'
import _ from 'lodash'
import ActionMenuV2 from 'components/ActionMenuV2'
import { PermissionSetMap } from 'constants/RBACConstants'
import ModalUtil from 'utils/modalUtil'
import ImpervaConfigFormPopup from './ImpervaConfigFormPopup'
import { PlayCircleOutlined } from '@ant-design/icons'
import message from 'components/CustomMessage'

const actions = [{
    type: "sync",
    text: "Sync Now",
    icon: <PlayCircleOutlined />,
},    
    {
    type: "edit",
    permission: PermissionSetMap.EDIT_TOOL_CONFIG,
}, {
    type: "delete",
    permission: PermissionSetMap.DELETE_TOOL,
}]

export default function ImpervaConfigListing({ data, onUpdateConfigComponent = _.noop, enabledAPI, loading }) {

    const onDelete = useCallback((id) => {
        return ImpervaAPI.deleteConfig(id).promise.then(() => onUpdateConfigComponent());
    }, [onUpdateConfigComponent]);

    const onSync = async (id) => {
        try {
            await ImpervaAPI.syncImperva(id).promise
            message.success("Successfully triggered sync, please check after some time.")
        }
        catch(e) {
            console.log(e)
        }
    }

    const onActionClick = useCallback(async (e, { name, data }) => {
        switch (name){
            case "edit":
                ModalUtil.show({
                    content: <ImpervaConfigFormPopup data={data} />,
                    afterClose: (success) => success && onUpdateConfigComponent()
                })
                break;
            case "delete":
                await onDelete(data.id);
                break;
            case "sync":
                onSync(data.id);
                break;
            default:
                break;
        }
    }, [onUpdateConfigComponent, onDelete]);

    const columns = [{
        title: "Name",
        dataIndex: "name",
        key: "name",
        sorter: Sorters.STRING("name")
    }, {
        title: "Endpoint",
        dataIndex: ["configs", "end_point"],
        key: "end_point",
        sorter: Sorters.STRING("configs.end_point")
    }, {
        title: "Search key",
        dataIndex: ["configs", "search_key"],
        key: "search_key",
        sorter: Sorters.STRING("configs.search_key")
    }, {
        title: "Sync frequency",
        dataIndex: ["configs", "frequency"],
        key: "frequency",
        sorter: Sorters.STRING("configs.frequency"),
        render: (value) => value.toLowerCase()
    }, {
        title: "Last synced on",
        dataIndex: "lastRun",
        key: "lastRun",
        sorter: Sorters.DATE("lastRun"),
        render: CellRenderers.TIME_RELATIVE
    }, {
        title: "Config",
        dataIndex: "enabled",
        key: "enabled",
        sorter: Sorters.STRING("enabled"),
        render: (enabled, record) => {
            return <ToggleButton text={enabled} record={record} integrationData={{updateAPI: enabledAPI}} onUpdateConfigComponent={onUpdateConfigComponent} />
        }
    }, {
        title: "Action",
        dataIndex: "id",
        render: (id, record) => {
            return (
                <ActionMenuV2 items={actions} onClick={onActionClick} data={record} />
            )
        }
    }]
    return (
        <TableContainer
             columns={columns}
             dataSource={data}
             loading={loading}
        />
     )
}
